export default "__VITE_ASSET__BqJIj5rb__"